import {
  formatDateNoTime,
  formatYDM,
  getToken,
  getUser,
} from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"

//GET
export const getAllInvoices = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "receives/get_all_receive",
      {
        requester: getUser(),
        token: getToken(),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const createBir2037PurchaseInvoice = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "Birform/receive_generate2307",
      {
        requester: getUser(),
        token: getToken(),
        receive_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getInvoice = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "receives/get_receive",
      {
        requester: getUser(),
        token: getToken(),
        receive_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getPaymentHistory = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "receives/get_all_invoice_payments",
      {
        requester: getUser(),
        token: getToken(),
        receive_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//POST
export const createInvoice = async (invoice, items, po_id) => {
  try {
    console.log(items)
    const formData = new FormData()
    invoice.attachments.map((file, index) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("po_id", po_id)
    formData.append("branch_id", invoice.branch_id)
    formData.append("supplier_id", invoice.supplier_id)
    formData.append("purchase_date", invoice.purchase_date)
    formData.append("receive_date", invoice.received_date)
    formData.append("forwarder_id", invoice.forwarder_id)
    formData.append("waybill_no", invoice.waybill_no || "")
    formData.append("invoice_no", invoice.invoice_no)
    formData.append("dr_no", invoice.dr_no)
    formData.append("freight_cost", invoice.freight_cost || 0)
    formData.append("discount", invoice.discount || 0)
    formData.append("remarks", invoice.remarks || "")
    formData.append("service_fee", invoice.service_fee || 0)
    formData.append("subtotal", invoice.subtotal)
    formData.append("grand_total", invoice.grand_total)
    formData.append("withholding_percentage", invoice.withholding_percentage)
    formData.append("vat_type", invoice.vat_type)
    formData.append("discounted_subtotal", invoice.discounted_subtotal)
    formData.append("vat", invoice.vat)
    formData.append("vatable_sales", invoice.vatable_sales)
    formData.append("withholding_tax", invoice.withholding_tax)
    formData.append(
      "grandtotal_without_service_fee",
      invoice.grandtotal_without_service_fee
    )

    items.map((item, index) => {
      formData.append(`item_ids[]`, item.item_id)
      formData.append(
        `descriptions[]`,
        item.description ? item.description : ""
      )
      formData.append(`quantities[]`, item.qtyInput)
      formData.append(`units[]`, item.unit)
      formData.append(`prices[]`, item.price)
      formData.append(`po_item_ids[]`, item.po_item_id)
      formData.append(`item_remarks[]`, item.remarks || "")
      formData.append(`discount_percentages[]`, item.discount_percentage || "0")
      formData.append(`discount_amounts[]`, item.discount_amount || "0")
      formData.append(`item_subamount[]`, item.subtotal)
      formData.append(`item_amount[]`, item.amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "receives/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const updateInvoice = async (invoice, items, id) => {
  try {
    const formData = new FormData()
    invoice.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    invoice.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("receive_id", id)
    formData.append("po_id", invoice.po_id)
    formData.append("branch_id", invoice.branch_id)
    formData.append("supplier_id", invoice.supplier_id)
    formData.append("purchase_date", invoice.purchase_date)
    formData.append("receive_date", invoice.receive_date)
    formData.append("forwarder_id", invoice.forwarder_id)
    formData.append("waybill_no", invoice.waybill_no || "")
    formData.append("invoice_no", invoice.invoice_no)
    formData.append("dr_no", invoice.dr_no)
    formData.append("freight_cost", invoice.freight_cost)
    formData.append("discount", invoice.discount || 0)
    formData.append("remarks", invoice.remarks || 0)
    formData.append("service_fee", invoice.service_fee || 0)
    formData.append("subtotal", invoice.subtotal)
    formData.append("grand_total", invoice.grand_total)

    formData.append("withholding_percentage", invoice.withholding_percentage)
    formData.append("vat_type", invoice.vat_type)
    formData.append("discounted_subtotal", invoice.discounted_subtotal)
    formData.append("vat", invoice.vat)
    formData.append("vatable_sales", invoice.vatable_sales)
    formData.append("withholding_tax", invoice.withholding_tax)
    formData.append(
      "grandtotal_without_service_fee",
      invoice.grandtotal_without_service_fee
    )

    items.map((item, index) => {
      formData.append(`item_ids[]`, item.item_id)
      formData.append(
        `descriptions[]`,
        item.description ? item.description : ""
      )
      formData.append(`quantities[]`, item.qtyInput)
      formData.append(`units[]`, item.unit)
      formData.append(`prices[]`, item.price)
      formData.append(`item_remarks[]`, item.remarks || "")
      formData.append(`po_item_ids[]`, item.po_item_id)
      formData.append(`discount_percentages[]`, item.discount_percentage || "0")
      formData.append(`discount_amounts[]`, item.discount_amount || "0")
      formData.append(`item_subamount[]`, item.subtotal)
      formData.append(`item_amount[]`, item.amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "receives/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deleteInvoice = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "receives/delete",
      {
        requester: getUser(),
        token: getToken(),
        receive_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deletePiAttachment = async (values) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "receives/delete_attachment",
      {
        requester: getUser(),
        token: getToken(),
        ...values,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const filterInvoice = async (filterConfig) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "receives/search",
      {
        requester: getUser(),
        token: getToken(),
        supplier_id: filterConfig.supplier || "",
        vendor_id: filterConfig.vendor_id || "",
        branch_id: filterConfig.branch_id,
        payment_status:
          filterConfig.payment_status === "all"
            ? ""
            : filterConfig.payment_status,
        receive_date_from: filterConfig.date_from
          ? formatYDM(filterConfig.date_from)
          : "",
        receive_date_to: filterConfig.date_to
          ? formatYDM(filterConfig.date_to)
          : "",
        invoice_no: filterConfig.invoice_no || "",
        anything: filterConfig.anything,
        page: filterConfig.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const closeOverpaidBill = async (id, remarks) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "receives/close_overpaid_receive",
      {
        requester: getUser(),
        token: getToken(),
        receive_id: id,
        remarks: remarks,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
